const CompanysSang = [
    {ID: -1 , Name : "All Items" , CompanyCategoryId: [1001 , 1002]},
    {ID: 1 , Name : "Abarghou Travertine" , CompanyCategoryId: [1001]},
    {ID: 2 , Name : "Abyaneh Travertine" , CompanyCategoryId: [1001]},
    {ID: 3 , Name : "Takab Travertine" , CompanyCategoryId: [1001]},
    {ID: 4 , Name : "Haji Abad Travertine" , CompanyCategoryId: [1001]},
    {ID: 5 , Name : "Darre Bakhari Travertine" , CompanyCategoryId: [1001]},
    {ID: 6 , Name : "Rameshe Travertine" , CompanyCategoryId: [1001]},
    {ID: 7 , Name : "Abbas Abad" , CompanyCategoryId: [1001]},
    {ID: 8 , Name : "Kashan" , CompanyCategoryId: [1001]},
    {ID: 9 , Name : "Mahallat" , CompanyCategoryId: [1001 , 1002]},
    {ID: 10 , Name : "Yazd" , CompanyCategoryId: [1001 , 1002]},
    {ID: 11 , Name : "Abadeh Marble" , CompanyCategoryId: [1002]},
    {ID: 12 , Name : "Salsali Marble" , CompanyCategoryId: [1002]},
    {ID: 13 , Name : "Lashtar Marble" , CompanyCategoryId: [1002]},
    {ID: 14 , Name : "Harsin" , CompanyCategoryId: [1002]},
]
export default CompanysSang;
